<template>
  <div class="page-wrapper" id="page-wrapper">
    <app-header />
    <div class="content">
      <router-view />
    </div>
    <ul class="sticky-appointment">
      <li class="ambulance stick-content">
        <a href="tel:281-2111" target="blank">
          <div class="img">
            <i class="fa fa-ambulance"></i>
          </div>
          <div class="desc">
            Emergency Call
            <span>281 2111</span>
          </div>
        </a>
      </li>
      <li class="call stick-content">
        <a href="tel:(0274)281-2999" target="blank">
          <div class="img">
            <i class="fa fa-phone"></i>
          </div>
          <div class="desc">
            Telp Hotline
            <span>(0274) 281 2999</span>
          </div>
        </a>
      </li>
      <li class="wa stick-content">
        <a
          href="https://api.whatsapp.com/send?phone=6282352266677"
          target="blank"
        >
          <div class="img">
            <i class="fa fa-whatsapp"></i>
          </div>
          <div class="desc">
            Hotline WA
            <span>0823 5226 6677</span>
          </div>
        </a>
      </li>
    </ul>
    <app-footer />
    <back-to-top visibleoffset="500">
      <button class="scrollToTop">
        <i class="fa fa-angle-up"></i>
      </button>
    </back-to-top>
  </div>
</template>

<script>
//Add element
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "RSUII",
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Welcome",
    // all titles will be injected into this template
    titleTemplate: "RSUII - %s"
  },
  components: {
    "app-header": Header,
    "app-footer": Footer
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue